define('vspot-angular/services/org-activity-service',['jquery'], function ($) {
    'use strict';


    return ['resources.OrgActivity', function (OrgActivity) {

        return {
            /*
             * Get a list of all the activities. Results are paginated.
             *
             * @param sortType - How the data should be sorted from the server.
             *                  The options sent are the language file key for the
             *                  options shown to the user. i.e. "_StartDate_", "_EndDate_", "_Title_".
             *
             * @param showOption - What data should be returned from the server.
             *                  The options sent are the language file key for the
             *                  options shown to the user. i.e. "_UpcomingSignUps_", "_PastSignUps_", "_OngoingSignUps_", "_AllSignUps_".
             * @param currentPage - Which page of the result set to show. 1 is the default.
             * @param items_per_page - How many items to show on each page of the result set. 10 is the default.
             *
             * @returns  Resource object. See /resources.js documentation for details
             */
            query: function(sortType, showOption, currentPage, items_per_page) {
                return OrgActivity.query({
                    order:              sortType,
                    show:               showOption,
                    page:               currentPage,
                    items_per_page:     items_per_page
                });
            },

            /*
             * get:
             *      Retrieve a single activity.
             *
             * @param {int} id = id of the activity to retrieve
             * @param {bool} lockActivity - request a lock on the activity at the same time we are requesting the activity data?
             * @param {bool} override - *if* lockActivity set, do we want to override another user's lock if it exists?
             * @param {bool} sendTotals - should the activity also calculate the progress.
             * @returns Resource object
             */
            get: function (id, lockActivity, override, sendTotals) {
                if(typeof(lockActivity) === "undefined") {
                    lockActivity = false;
                }

                if(typeof(override) === "undefined") {
                    override = false;
                }

                if(typeof(sendTotals) === "undefined") {
                    sendTotals = false;
                }

                return OrgActivity.get({
                    id:                 id,
                    selected_activity:  id, // For compatibility acrosss APIs - Carol's request
                    lock:               lockActivity,
                    ignore_lock:        override,
                    sendtotals:         sendTotals
                });
            },

            /*
             * save:
             *      Create a single activity.
             *
             * @param {object} postData = Data from the form
             *
             * @returns Resource object
             */
            save: function (postData) {
                return OrgActivity.save(postData);
            },

            /*
             * update:
             *      Save changes to a single activity.
             *
             * @param {object} postData = Data from the form
             *
             * @returns Resource object
             */
            update: function (postData) {
                $.extend(postData, {selected_activity: postData.id}); // For compatibility acrosss APIs - Carol's request
                return OrgActivity.update(postData);
            },

            /*
             * This function actually moves the signpup into an archived state.
             * Previously we didn't expose the archive to users, but this is now
             * changing so that users and see their archived activites and restore them.
             *
             * @param {int} id = id of the activity to archive.
             */
            delete: function(id) {
                return OrgActivity.delete({
                    id:                 id,
                    selected_activity:  id // For compatibility acrosss APIs - Carol's request
                });
            },

            // Custom Questions section
            createExtraField: function(id,postData) {
                return OrgActivity.createExtraField({
                    selected_activity:  id, // For compatibility acrosss APIs - Carol's request
                    order: postData.order,                             
                    field_number: postData.field_number,                        
                    required: postData.required,                          
                    title: postData.title,          
                    format: postData.format,                  
                    values: postData.values,
                    min: postData.min,
                    max: postData.max,
                    comment: postData.comment
                });
            },

            updateExtraField: function(id, postData) {
                var data = {
                    selected_activity:  id, // For compatibility acrosss APIs - Carol's request
                    order: postData.order,                             
                    field_number: postData.field_number,                        
                    required: postData.required,                          
                    title: postData.title,          
                    format: postData.format,                  
                    values: postData.values,
                    min: postData.min,
                    max: postData.max,
                    comment: postData.comment
                }
                if (postData.activity_extra_field_id) {
                    data.activity_extra_field_id = postData.activity_extra_field_id;
                } else if (postData.definition_id) {
                    data.definition_id = postData.definition_id;
                }
                return OrgActivity.updateExtraField(data);
            },

            deleteExtraField: function(id, definition_id, activity_extra_field_id) {
                return OrgActivity.deleteExtraField({
                    selected_activity:  id, // For compatibility acrosss APIs - Carol's request
                    definition_id: definition_id,
                    activity_extra_field_id: activity_extra_field_id  
                });
            },
            

            /*
             * More than regular destroy. This function still doesn't
             * delete the signup because Carol is paranoid. But it does keep
             * the user from seeing the signup in their archived list.
             *
             * @param {int} id = id of the activity to really delete.
             */
            reallyDestroy: function(id) {
                return OrgActivity.reallyDestroy({
                    id:                 id,
                    selected_activity:  id // For compatibility acrosss APIs - Carol's request
                });
            },

            /*
             * For an activity that have been "destroyed", but not "really
             * destroyed", we can use this function to restore it.
             *
             * @param {int} id = id of the activity to restore
             */
            restoreArchivedActivity: function(id) {
                return OrgActivity.restoreArchivedActivity({
                    id:                 id,
                    selected_activity:  id // For compatibility acrosss APIs - Carol's request
                });
            },

            /*
             * Gets a full list of activities, not paginated.
             *
             * @param:  sendTitles - {boolean} Set to true for just id and title,
             *                       false for the full data set.
             * @param:  includePast - {boolean} Set to true to include past activities.
             * @param:  include_incomplete - {boolean} Set to true to include incomplete activities.
             * @param:  imagesOnly  - {boolean} Set to true to only return activities that uploaded
             *                        images (badges don't count).
             *
             * @returns  Resource object. See /resources.js documentation for details
             */
            summary: function (sendTitles, includePast, includeIncomplete, imagesOnly) {
                return OrgActivity.summary({
                    send_titles:        sendTitles,
                    include_past:       includePast,
                    include_incomplete: includeIncomplete,
                    images_only:        imagesOnly
                });
            },

            /*
             * Unlock an activity
             *
             * @param {int} id = id of the activity to unlock
             *
             * @returns  Resource object. See /resources.js documentation for details
             */
            unlockActivity: function(id) {
                return OrgActivity.unlockActivity({
                    selected_activity: id
                });
            },

            /*
             *  Returns whether or not a particular activity has jobs or wampum amounts.
             *
             * @param {int} id = id of the activity to check.
             *
             *  @returns  Resource object. See /resources.js documentation for details
             *            { status: boolean, hasSpots: boolean }
             */
            hasSpots: function (id) {
                return OrgActivity.hasSpots({ selected_activity: id });
            },

            /*
             *  Returns status counts for the logged in user (number of activities of each type).
             *
             *  @returns  Resource object. See /resources.js documentation for details
             *            {"status": boolean, "upcoming": int, "past": int, "ongoing": int, "all": int}
             */
            getCounts: function () {
                return OrgActivity.getCounts();
            },

            /*
             *  Adds a waiver to an activity. If a waiver exists, a new version will be recorded.
             *
             * @param {int} id = id of the activity to create a waiver for
             * @param {obj} data = the data for the waiver... would be good to add a description.
             *
             *  @returns  Resource object. See /resources.js documentation for details
             */
            createWaiver: function (id, data) {
                data.selected_activity = id;
                return OrgActivity.createWaiver(data);
            },

            /*
             *  Retrieves the latest waiver for the given activity.
             *
             * @param {int} id = id of the activity to retrieve the waiver for.
             *
             *  @returns  Resource object. See /resources.js documentation for details
             */
            getWaiver: function (id) {
                return OrgActivity.getWaiver({ selected_activity: id });
            },

            /*
             *  Updates an activity's waiver. For now, only updates whether a waiver is
             *  enabled or disabled (show/hide from participant's view).
             *
             * @param {int} id = id of the activity to create a waiver for.
             * @param {obj} data = the data for the waiver... would be good to add a description.
             *
             *  @returns  Resource object. See /resources.js documentation for details
             */
            updateWaiver: function (id, data) {
                data.selected_activity = id;
                return OrgActivity.updateWaiver(data);
            },

            /*
             *  Gets the list of groups that a given activity has
             *  been published to.
             *
             * @param {int} id = id of the activity to find the groups for.
             *
             *  @returns  Resource object. See /resources.js documentation for details
             */
            getGroupsPublishedTo: function (id) {
                return OrgActivity.getGroupsPublishedTo({ selected_activity: id });
            },

            /*
             *  Upload an image for an activity.
             *
             * @param {int} id = id of the activity to upload the image for.
             * ??? Something seems odd, the file data isn't referenced.
             *
             *  @returns Resource object. See /resources.js documentation for details
             */
            uploadImage: function (id) {
                return OrgActivity.uploadImage({ activity_id: id });
            },

            /*
             *  Remove an activity from an image.
             *
             * @param {int} id = id of the activity to remove the image for.
             *
             *  @returns Resource object. See /resources.js documentation for details
             */
            removeImage: function (id) {
                return OrgActivity.removeImage({ activity_id: id });
            },

            /*
             *  Copy the image from one activity to another.
             *
             * @param {int} srcId = id of the activity to copy the image FROM.
             * @param {int} id = id of the activity to copy the image TO.
             *
             *  @returns Resource object. See /resources.js documentation for details
             */
            copyImage: function (srcId, id) {
                return OrgActivity.copyImage({
                    src_activity_id:    srcId,
                    activity_id:        id
                });
            },

            /*
             *  Get the large activity image.
             *
             * @param {int} id = id of the activity to get the large image for.
             *
             *  @returns Resource object. See /resources.js documentation for details
             */
            getLargeActivityImage: function (id) {
                return OrgActivity.getLargeActivityImage({
                    activity_id: id
                });
            },

            /*
             *  Get the suggestions (drop-down items) for the extra fields.
             *
             * @param {int} id = id of the activity to get the extra fields suggestions for.
             *
             *  @returns Resource object. See /resources.js documentation for details
             */
            extraFieldsSuggestions: function (id) {
                return OrgActivity.extraFieldsSuggestions({
                    activity_id: id
                });
            },

            newExtraFieldsSuggestions: function (id) {
                return OrgActivity.newExtraFieldsSuggestions({
                    selected_activity: id
                });
            },

            /*
             * Get the Open/Close info.
             *
             * @param {int} id = id of the activity to get the info for.
             *
             * @returns Resource object. See /resources.js documentation for details
             */
            getActivityLockInfo: function (id) {
                return OrgActivity.getActivityLockInfo({
                    selected_activity: id
                });
            },

            /*
             * Set the Open/Close info.
             *
             * @param {int} id = id of the activity to get the info for.
             * @param {obj} data = the data of the lock info. See resource object for accepted options
             *
             * @returns Resource object. See /resources.js documentation for details
             */
            setActivityLockInfo: function (id, data) {
                data.selected_activity = id;
                return OrgActivity.setActivityLockInfo(data);
            },
            /*
             * Get the Open/Close info.
             *
             * @param {int} id = id of the activity to get the info for.
             *
             * @returns Resource object. See /resources.js documentation for details
             */
            getRollingActivityLockInfo: function (id) {
                return OrgActivity.getRollingActivityLockInfo({
                    selected_activity: id
                });
            },

            /*
             * Set the Open/Close info.
             *
             * @param {int} id = id of the activity to get the info for.
             * @param {obj} data = the data of the lock info. See resource object for accepted options
             *
             * @returns Resource object. See /resources.js documentation for details
             */
            setRollingActivityLockInfo: function (id, data) {
                data.selected_activity = id;
                return OrgActivity.setRollingActivityLockInfo(data);
            }
        };
    }];
});

